import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FiUsers,
  FiVideo,
  FiTarget,
  FiDollarSign,
  FiClock,
  FiLayers,
  FiBookOpen,
} from "react-icons/fi";

const navItems = [
  { label: "Leads", to: "dashboard-leads", icon: FiUsers },
  { label: "Demo", to: "dashboard-demo", icon: FiVideo },
  { label: "Nurturing", to: "dashboard-nurturing", icon: FiTarget },
  { label: "First Installment", to: "dashboard-first-installment", icon: FiDollarSign },
  { label: "Pending Installments", to: "dashboard-pending-installments", icon: FiClock },
  { label: "Enrollments", to: "dashboard-enrollments", icon: FiBookOpen },
];

export default function SideBar() {
  const location = useLocation();
  const path = location.pathname || "";

  // Determine base prefix: prefer admin if path contains it, otherwise user
  const base =
    path.startsWith("/admin-home") || path.startsWith("/admin")
      ? "/admin-home"
      : "/user-home";

  return (
    <aside className="h-screen w-64 bg-gradient-to-b from-[#ffffff] via-[#f8f9fb] to-[#eef1f6] border-r border-gray-200 shadow-xl flex flex-col justify-between">
      {/* Header */}
      <div className="px-5 py-6 border-b border-gray-200">
        <div className="flex items-center gap-3">
          <FiLayers className="text-2xl text-gray-800" />
          <h2 className="text-lg font-semibold tracking-wide text-gray-800">Dashboards</h2>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4">
        <ul className="space-y-1">
          {navItems.map(({ label, to, icon: Icon }) => {
            const fullPath = `${base}/${to}`;
            const starts = path.startsWith(fullPath);

            return (
              <li key={to}>
                <NavLink
                  to={fullPath}
                  className={({ isActive }) => {
                    const active = isActive || starts;
                    return [
                      "flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-all duration-200 ease-in-out",
                      active
                        ? "bg-[#111827] text-white shadow-md transform scale-[1.02]"
                        : "text-gray-700 hover:bg-gray-100 hover:text-gray-900 hover:translate-x-[2px]",
                    ].join(" ");
                  }}
                >
                  <Icon
                    className={`text-lg transition-transform duration-200 ${
                      path.startsWith(fullPath) ? "scale-110" : "group-hover:scale-110"
                    }`}
                  />
                  <span className="truncate">{label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="px-5 py-4 text-xs text-center text-gray-500 border-t border-gray-200">
        © 2025 Practical Infosec
      </div>
    </aside>
  );
}
